import { render } from "./PrimarySources.vue?vue&type=template&id=719ef15e&scoped=true"
import script from "./PrimarySources.vue?vue&type=script&lang=js"
export * from "./PrimarySources.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=719ef15e&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719ef15e"]])

export default __exports__